import React, { useCallback } from "react"
import { useHookstate } from "@hookstate/core"
import { Col, Row } from "react-bootstrap"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useConfigDataState } from "../../globalStates/ConfigDataState"
import { hasServiceKeys } from "../../globalStates/ConfigDataState"
import FilePicker from "../../components/FilePicker"
import Section from "../../components/Section"

const LogoSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()
    const organizationState = exiState.getOrganization()
    const organization = useHookstate(organizationState)
    const serviceKeys = useConfigDataState().getServiceKeys()
    const logoVisible = hasServiceKeys(serviceKeys.logo)
    const headerGraphicVisible = hasServiceKeys(serviceKeys.headerGraphic)

    const onChangeLogo = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("LOGO", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        organization.logoFileId.set(response.fileId)
                        organization.logoUrl.set(response.fileUrl)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, organization]
    )

    const onChangeBackground = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("BACKGROUND_IMAGE", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        organization.backgroundImageFileId.set(response.fileId)
                        organization.backgroundImageUrl.set(response.fileUrl)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, organization]
    )

    const onRemoveLogo = useCallback(() => {
        organization.logoFileId.set("")
        organization.logoUrl.set("")
    }, [organization])

    const onRemoveBackground = useCallback(() => {
        organization.backgroundImageFileId.set("")
        organization.backgroundImageUrl.set("")
    }, [organization])

    return (
        <Section title={branding.configuration.profilePage.sctUpload.lblUpload}>
            <Row>
                {logoVisible && (
                    <Col sm={12} md={3}>
                        <FilePicker
                            name="companyLogo"
                            label={branding.configuration.profilePage.sctUpload.lblCompanyLogo}
                            placeholderTitle={branding.configuration.profilePage.sctUpload.hntTitle}
                            placeholderText={branding.configuration.profilePage.sctUpload.hntProp}
                            browseLabel={branding.configuration.profilePage.sctUpload.btnBrowseFilesLogo}
                            deleteLabel={branding.configuration.profilePage.sctUpload.btnDeleteImgLogo}
                            value={organization.logoUrl.get()}
                            onChangeImage={onChangeLogo}
                            onRemoveImage={onRemoveLogo}
                        />
                    </Col>
                )}
                {headerGraphicVisible && (
                    <Col sm={12} md={9}>
                        <FilePicker
                            name="companyBackground"
                            label={branding.configuration.profilePage.sctUpload.lblCompanyBackground}
                            placeholderTitle={branding.configuration.profilePage.sctUpload.hntTitleBackground}
                            placeholderText={branding.configuration.profilePage.sctUpload.hntPropBackground}
                            browseLabel={branding.configuration.profilePage.sctUpload.btnBrowseFilesBackground}
                            deleteLabel={branding.configuration.profilePage.sctUpload.btnDeleteImgBackground}
                            value={organization.backgroundImageUrl.get()}
                            onChangeImage={onChangeBackground}
                            onRemoveImage={onRemoveBackground}
                        />
                    </Col>
                )}
            </Row>
        </Section>
    )
}

export default LogoSection
